"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageOne = void 0;
exports.pageOne = () => ({
    // pageSize: { width: 550, height: 700 },
    content: [
        {
            style: 'tableText',
            columns: [
                {
                    // auto-sized columns have their widths based on their content
                    width: '*',
                    // A stack treats each index as its own line.
                    stack: [
                        'Address: Pickles',
                        'City/State/Zip:A SC 92068',
                        'Home Phone: (555) 555-5555',
                        'Cell Phone:        ',
                        'Work Phone:        ',
                        'Dispense Time: 08/30/18 11:25 am',
                        'Reimbursement:  ',
                        'Site Number#: 4232752',
                        'Name: Palmetto Physical Medicine (Anderson)',
                        'Address: 10 Financial Blvd Anderson SC 29621',
                        'Phone: (864) 437-8930',
                        'Fax: ',
                        'User: ',
                        'Payer: ',
                        'Address: ',
                        'Phone: ',
                        'Is Dept of Labor: ',
                        'Adjuster: ',
                        'Verfied: ',
                    ],
                },
                {
                    // star-sized columns fill the remaining space
                    // if there's more than one star-column, available width is divided equally
                    width: '*',
                    stack: [
                        'Gender: Female',
                        'SSN:',
                        'DOB: 08/22/1957',
                        'Claim #:',
                        'Injury:',
                        'Approved:',
                        'Group:',
                        'Doc: Doctor, Test MD (Anderson SC) NPI#',
                        'DEA #:Provider DEA #',
                        'State License #: ',
                        'Tax ID: ',
                        'NPI: ',
                        'Active Prov#: ',
                        '\n\n\n Employer: ',
                        'Address: ',
                        'Phone: ',
                    ],
                },
                // To place an image within a column you must place it within a stack or else it will
                // not render.
                {
                    width: 100,
                    stack: [
                        // {image: 'barcodeImage.png', width: 100},
                        'Thu 08/30/18 3:12:55PM',
                        'Alex Harris',
                        '\n\n\n\n\n\n\n\n\nAttorney: ',
                        'Practice: ',
                        'Address: ',
                        'Phone: ',
                        'Fax: ',
                    ],
                },
            ],
            // optional space between columns
            columnGap: 50,
        },
        {
            layout: {
                hLineWidth(i, node) {
                    return (i === 0 || i === node.table.body.length) ? 1 : .5;
                },
                vLineWidth(i, node) {
                    return (i === 0 || i === node.table.widths.length) ? .5 : .5;
                },
            },
            style: 'tableText',
            table: {
                // headers are automatically repeated if the table spans over multiple pages
                // you can declare how many rows should be treated as headers
                headerRows: 1,
                widths: [25, 25, 70, 50, 10, 60, 70, 15, 30, 30, 30, 30],
                body: [
                    ['Rx #', 'ICD10', 'NDC', 'RefNDC', 'B', 'Name', 'Form', 'Lot', 'AWP', 'MAC', 'Reim', 'Status'],
                    ['324', 'A00', '76420-0720-01', '76420-0720', '', 'Bupivilog Kit', 'Value 6', '', '0', '', '0.00', 'Paid'],
                    ['324', 'A00', '76420-0720-01', '76420-0720', '', 'Bupivilog Kit', 'Value 6', '', '0', '', '0.00', 'Paid'],
                    ['324', 'A00', '76420-0720-01', '76420-0720', '', 'Bupivilog Kit', 'Value 6', '', '0', '', '0.00', 'Paid'],
                ],
            },
        },
        {
            text: 'NOTICE: Page contains private patient information and should be handled in accordance with \n HIPAA guidelines to protext the privace of the patient',
            style: 'notice',
            pageBreak: 'after',
        },
    ],
    styles: {
        tableText: {
            fontSize: 8,
            bold: false,
            margin: [-20, 15, 0, 0],
            alignment: 'left',
        },
        notice: {
            fontSize: 8,
            margin: [50, 30, 0, 0],
            alignment: 'center',
        },
        barcode: {
            alignment: 'center',
        },
    },
});



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/pdfs/firstPage.ts
// module id = 2728
// module chunks = 0 1